<template>
    <div 
      class="timeout" 
      @mousemove="userEngaged" 
      @wheel="userEngaged"
      @touchstart="userEngaged"
    >
      <video 
        width="800" 
        height="450" 
        autoplay 
        loop
        muted 
        playsinline
        class="timeout__video"
      >
        <source :src="props.video" type="video/mp4">
    </video>
    </div>
</template>

<script setup>
  import { defineProps, ref } from 'vue';
  import { useAllisStore } from '../../stores/allis';

  const allis = useAllisStore(); 

  const props = defineProps({
  video: String,
});
  
  const userEngaged = () => {
    allis.userIdle = false;
  };
</script>

<style scoped lang="scss">
.timeout {
  position: fixed;
  z-index: 9999999;
  width: 100%;
  height: 100dvh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  &__video {
    height: auto;
    width: 98vw;
    @media only screen and (min-width: 1025px) {
      height: 80dvh;
      width: auto;
    }
  }
}
</style>
